import { ProductTypeEnum as t } from "../../enums/product-type-enum.mjs";
import { StoreItemEnum as u } from "../../../../enums/store-item-enum.mjs";
const e = {
  type: u.product,
  productType: t.physicalProduct,
  title: "My Physical Product!",
  subTitle: "My Physical Product subtitle",
  buttonTitle: "BUY NOW",
  thumbnail: null,
  checkoutPage: {}
};
export {
  e as defaultPhysicalProductValues
};
